"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
require("../style/style.scss");
var AppConfig_1 = require("./AppConfig");
var ChartManager_1 = require("./ChartManager");
var ConfGetter_1 = require("./ConfGetter");
var DataContainer_1 = require("./DataContainer");
var DataGetter_1 = require("./DataGetter");
var Message_1 = require("./Message");
var isNumeric_1 = require("./format/isNumeric");
$(document).ready(function () {
    var referrerUrl = document.referrer;
    var paths = location.pathname.split('/');
    AppConfig_1.AppConfig.APP_CONFIG.mierukaWebId = paths.slice(-1)[0];
    Message_1.Message.log(AppConfig_1.AppConfig.APP_CONFIG.mierukaWebId);
    var fragmentId = location.hash.substring(1);
    var mierukaWebViewer = new MierukaWebViewer(fragmentId, referrerUrl);
    window.mierukaWebViewer = mierukaWebViewer;
    mierukaWebViewer.init();
});
var MierukaWebViewer = (function () {
    function MierukaWebViewer(fragmentId, referrerUrl) {
        var _this = this;
        this.referrerUrl = '';
        this.isInternalLinkProcess = false;
        this.isDefaultTabSetting = true;
        this.crusingList = [];
        this.linkButtonSettings = {};
        this.alwaysHiddenButtonsList = {};
        this.currentListIndex = 0;
        this.isCrusingWithList = false;
        this.isUnloadedScreen = false;
        this.isBackToPreScreen = false;
        this.currentId = 0;
        this.screenCount = 0;
        this._isAutoCruise = true;
        this.unLoadedFrame = [];
        this.virtualScreen = [];
        this.checkCount = 0;
        this.isInitialized = false;
        this.getIemConf = this.getItemConf;
        this.init = function () {
            var resizeInervalMSEC = 200;
            Message_1.Message.init();
            window.onresize = function () {
                clearTimeout(_this.resizeTimer);
                _this.resizeTimer = setTimeout(_this.resizeScreen, resizeInervalMSEC);
            };
            if (AppConfig_1.AppConfig.APP_CONFIG.debugMode) {
                $('header').show();
                $('#previousScreenButton').on('click', _this.preScreen);
                $('#nextScreenButton').on('click', _this.nextScreen);
                $('#autoPlay').on('click', _this.startAutoCruise);
                $('#pause').on('click', _this.stopAutoCruise);
                $('#cruiseTitle').text(AppConfig_1.AppConfig.cruiseKey);
            }
            _this.setUp();
        };
        this.isConfigV3 = function (config) {
            return config.premium && config.version === 3;
        };
        this.setUpForLinkableCrusing = function () {
            _this.isCrusingWithList = true;
            if (!_this.isConfigV3(DataContainer_1.DataContainer.config))
                return;
            _this.crusingList = DataContainer_1.DataContainer.config.crusingList;
            _this.isDefaultTabSetting = DataContainer_1.DataContainer.config.isDefaultTabSetting;
            DataContainer_1.DataContainer.config.screens.forEach(function (value, screenId) {
                if (value.linkButtonSettings) {
                    _this.linkButtonSettings[screenId] = value.linkButtonSettings;
                }
                if (value.alwaysHiddenButtons)
                    _this.alwaysHiddenButtonsList[screenId] = value.alwaysHiddenButtons;
            });
            if (typeof _this.firstFragedScreenId === 'undefined') {
                _this.firstFragedScreenId = _this.crusingList[0];
                _this.changeLocationHash("".concat(_this.firstFragedScreenId));
            }
            else if (_this.crusingList.indexOf(_this.firstFragedScreenId) === -1) {
                if (!_this.isInternalLinkProcess) {
                    _this.firstFragedScreenId = _this.crusingList[0];
                }
                else {
                    _this.isInternalLinkProcess = false;
                    _this.stopAutoCruise();
                }
                _this.changeLocationHash("".concat(_this.firstFragedScreenId));
            }
            else {
                _this.currentListIndex = _this.crusingList.indexOf(_this.firstFragedScreenId);
            }
        };
        this.changeLocationHash = function (fragmentId) {
            location.replace("".concat(MierukaWebViewer.URL_WITHOUT_HASH, "#").concat(fragmentId));
        };
        this.validateFragmentId = function (fragmentId) {
            if (!fragmentId || fragmentId.match('[^0-9]')) {
                _this.currentListIndex = 0;
                _this.changeLocationHash("".concat(_this.crusingList[0]));
            }
            else if (_this.crusingList.indexOf(Number(fragmentId)) === -1) {
                if (_this.isInternalLinkProcess) {
                    _this.isInternalLinkProcess = false;
                    if (_this._isAutoCruise)
                        _this.stopAutoCruise();
                    _this.toggleTickEventListener();
                    _this.showScreen(Number(fragmentId));
                }
                else {
                    _this.currentListIndex = 0;
                    _this.changeLocationHash("".concat(_this.crusingList[0]));
                }
            }
            else {
                if (_this.isBackToPreScreen) {
                    _this.isBackToPreScreen = false;
                    _this.currentListIndex = _this.currentListIndex
                        ? _this.currentListIndex - 1
                        : _this.crusingList.length - 1;
                }
                else if (_this.crusingList.indexOf(Number(fragmentId), _this.currentListIndex) === -1) {
                    _this.currentListIndex = _this.crusingList.indexOf(Number(fragmentId));
                }
                else {
                    _this.currentListIndex = _this.crusingList.indexOf(Number(fragmentId), _this.currentListIndex);
                }
                if (_this._isAutoCruise) {
                    _this.stopAutoCruise();
                    _this.toggleTickEventListener();
                    _this._isAutoCruise = true;
                    _this.showScreen(Number(fragmentId));
                    _this.startAutoCruise();
                }
                else {
                    _this.toggleTickEventListener();
                    _this.showScreen(Number(fragmentId));
                }
            }
        };
        this.isCustomWindow = function (window) {
            return window !== null && 'onLoaded' in window;
        };
        this.checkScreen = function () {
            _this.checkCount++;
            if (_this.unLoadedFrame.length !== _this.checkCount) {
                return;
            }
            _this.unLoadedFrame.forEach(function (frame) {
                if (!_this.isCustomWindow(frame.contentWindow))
                    return;
                var onLoaded = frame.contentWindow.onLoaded;
                if (onLoaded === undefined)
                    return;
                if (onLoaded.length) {
                    onLoaded(Number(frame.id.replace('screen_', '')));
                }
                else {
                    onLoaded();
                }
            });
            _this.unLoadedFrame = [];
            _this.checkCount = 0;
            if (!_this.isInitialized || _this.isUnloadedScreen)
                _this.toggleTickEventListener();
            if (_this.currentFrame[0].contentWindow.playScreen) {
                _this.currentFrame[0].contentWindow.playScreen();
            }
            if (_this.currentFrame[0].contentWindow.switchButtonVisible) {
                _this.currentFrame[0].contentWindow.switchButtonVisible(!_this._isAutoCruise);
            }
            if (_this.isInitialized === false) {
                _this.isInitialized = true;
                _this.startAutoCruise();
                _this.updateValue();
                _this.hidePreLoader();
            }
            if (_this.isUnloadedScreen) {
                _this.isUnloadedScreen = false;
                _this.updateValue();
                _this.hidePreLoader();
            }
        };
        this.updateValue = function () {
            if (_this.currentFrame[0].contentWindow.update) {
                _this.currentFrame[0].contentWindow.update();
            }
        };
        this.showPreLoader = function () {
            Message_1.Message.showMessage(Message_1.Message.LOADING);
        };
        this.hidePreLoader = function () {
            Message_1.Message.hideMessage();
        };
        this.toggleTickEventListener = function () {
            if (_this.currentFrame[0].contentWindow.toggleTickEventListener) {
                _this.currentFrame[0].contentWindow.toggleTickEventListener();
            }
        };
        this.createFrame = function (id) {
            var screenEndPoint = DataContainer_1.DataContainer.config.bucketPath +
                DataContainer_1.DataContainer.config.screens[id].asset.assetId +
                DataContainer_1.DataContainer.config.screens[id].asset.path;
            var frameId = _this.getFrameIdString(id);
            var frame = $('#frameTemplate').clone();
            frame.attr('id', frameId);
            frame.attr('src', screenEndPoint);
            frame.css('position', 'absolute');
            _this.virtualScreen.push(frame);
        };
        this.showScreen = function (id) {
            _this.currentId = id;
            var iframeContainer = $('#iframeContainer');
            var idList = [id];
            if (_this.isInitialized && !iframeContainer.find("#".concat(_this.getFrameIdString(id))).length) {
                _this.showPreLoader();
                _this.isUnloadedScreen = true;
            }
            if (2 === _this.screenCount) {
                var nextFrameId = _this.countScreenIndex(1);
                _this.hideScreen(nextFrameId);
                idList.push(nextFrameId);
            }
            if (3 <= _this.screenCount) {
                var nextFrameId = _this.countScreenIndex(1);
                _this.hideScreen(nextFrameId);
                var preFrameId = _this.countScreenIndex(-1);
                _this.hideScreen(preFrameId);
                idList.push.apply(idList, [nextFrameId, preFrameId]);
            }
            var frameIdList = idList.map(function (id) { return _this.getFrameIdString(id); });
            iframeContainer.find('.screenFrame').each(function (id, element) {
                if (frameIdList.indexOf(element.id) === -1) {
                    var chartId = element.id.replace('screen', 'graphID');
                    ChartManager_1.ChartManager.destroyChartById(chartId);
                    $(element).attr('src', '');
                    $(element).empty();
                    $(element).remove();
                }
            });
            idList.forEach(function (id) {
                if (!iframeContainer.find("#".concat(_this.getFrameIdString(id))).length) {
                    var frame = $(_this.virtualScreen[id][0]).clone(true);
                    _this.unLoadedFrame.push(frame[0]);
                    iframeContainer.append(frame);
                    frame[0].contentWindow.getScreenConf = function () {
                        return DataContainer_1.DataContainer.config.screens[id];
                    };
                }
            });
            $('#index').text(_this.currentId);
            _this.currentFrame = $("#".concat(_this.getFrameIdString(id)));
            AppConfig_1.AppConfig.APP_CONFIG.currrentFrame = _this.currentFrame;
            _this.currentFrame.css('visibility', 'visible');
            _this.currentFrame.css('z-index', '500');
            _this.resizeScreen();
            _this.updateValue();
            _this.toggleTickEventListener();
            if (_this.currentFrame[0].contentWindow.playScreen) {
                _this.currentFrame[0].contentWindow.playScreen();
            }
            if (_this.currentFrame[0].contentWindow.switchButtonVisible) {
                var visible = _this.unLoadedFrame.length === 0 && !_this._isAutoCruise;
                _this.currentFrame[0].contentWindow.switchButtonVisible(visible);
            }
        };
        this.hideAllScreen = function () {
            var app = _this;
            $('.screenFrame').each(function (index) {
                app.hideScreen(index);
            });
        };
        this.hideScreen = function (screenId) {
            $("#".concat(_this.getFrameIdString(screenId))).css('visibility', 'hidden');
            $("#".concat(_this.getFrameIdString(screenId))).css('z-index', '0');
        };
        this.getFrameIdString = function (id) {
            return "screen_".concat(String(id));
        };
        this.nextScreen = function () {
            if (_this.isCrusingWithList) {
                _this.changeLocationHash("".concat(_this.countScreenIndex(1)));
            }
            else {
                _this.showScreen(_this.countScreenIndex(1));
            }
        };
        this.preScreen = function () {
            if (_this.isCrusingWithList) {
                _this.isBackToPreScreen = true;
                _this.changeLocationHash("".concat(_this.countScreenIndex(-1)));
            }
            else {
                _this.showScreen(_this.countScreenIndex(-1));
            }
        };
        this.startAutoCruise = function () {
            _this._isAutoCruise = true;
            var msecCoefficient = 1000;
            var cruiseTime = Number(DataContainer_1.DataContainer.config.common.displayTime) * msecCoefficient;
            var displayTime = _this.getCurrentScreenConf().displayTime;
            if (typeof displayTime === 'number' && displayTime >= 0) {
                cruiseTime = displayTime * msecCoefficient;
            }
            if (_this.cruiseTimer) {
                clearTimeout(_this.cruiseTimer);
            }
            _this.cruiseTimer = setTimeout(function () {
                _this.nextScreen();
                _this.startAutoCruise();
            }, cruiseTime);
        };
        this.stopAutoCruise = function () {
            _this._isAutoCruise = false;
            clearTimeout(_this.cruiseTimer);
        };
        this.getCurrentScreenConf = function () {
            var result = DataContainer_1.DataContainer.config.screens[_this.currentId];
            result.id = _this.currentId;
            return result;
        };
        this.isScreenConfigSkeleton = function (value) {
            return value.type === 'skeleton';
        };
        this.countScreenIndex = function (count) {
            if (_this.isCrusingWithList) {
                var listElementCount = _this.crusingList.length;
                var calc_1 = _this.currentListIndex + count;
                var maxId_1 = listElementCount - 1;
                if (calc_1 > maxId_1) {
                    return _this.crusingList[calc_1 - listElementCount];
                }
                if (calc_1 < 0) {
                    return _this.crusingList[listElementCount + calc_1];
                }
                return _this.crusingList[calc_1];
            }
            var calc = _this.currentId + count;
            var maxId = _this.screenCount - 1;
            if (calc > maxId) {
                return calc - _this.screenCount;
            }
            if (calc < 0) {
                return _this.screenCount + calc;
            }
            return calc;
        };
        this.createChart = function (targetId, chartDiv) {
            ChartManager_1.ChartManager.createChart("graphID_".concat(targetId), chartDiv, targetId);
        };
        this.updateChartById = function (chartId, targetId) {
            ChartManager_1.ChartManager.updateChartById(chartId, targetId);
        };
        this.getChartInstanceById = function (chartId) {
            return ChartManager_1.ChartManager.getChartInstanceById(chartId);
        };
        this.resizeScreen = function () {
            $('#iframeContainer')
                .find('.screenFrame')
                .each(function (index, iframe) {
                var targetFrame = $(iframe);
                var height = Number($(window).height());
                var width = Number($(window).width());
                targetFrame.css('width', "".concat(String(width), "px"));
                targetFrame.css('height', "".concat(String(height), "px"));
            });
        };
        this.formatNumber = function (str) {
            return str
                .toString()
                .replace(/(\d)(?=(?:\d{3}){2,}(?:\.|$))|(\d)(\d{3}(?:\.\d*)?$)/g, '$1$2,$3');
        };
        this.reboot = function () {
            var nowDate = new Date();
            if (2 === nowDate.getHours()) {
                location.reload();
            }
        };
        this.openInternalLink = function (screenId, newTab) {
            if (newTab === void 0) { newTab = false; }
            if (!newTab) {
                _this.isInternalLinkProcess = true;
                _this.changeLocationHash("".concat(screenId));
            }
            else {
                window.open("".concat(MierukaWebViewer.URL_WITHOUT_HASH, "#").concat(screenId).concat(MierukaWebViewer.HASH_FOR_INTERNAL_LINK));
            }
        };
        this.openExternalLink = function (url, newTab) {
            if (newTab === void 0) { newTab = true; }
            if (newTab) {
                window.open(url);
            }
            else {
                window.location.href = url;
            }
        };
        this.backToReferrer = function (newTab) {
            if (newTab === void 0) { newTab = false; }
            if (!_this.referrerUrl)
                return;
            if (!newTab) {
                window.location.href = _this.referrerUrl;
            }
            else {
                window.open(_this.referrerUrl);
            }
        };
        this.processLink = function (linkButtonSetting) {
            switch (linkButtonSetting.type) {
                case 'internal':
                    if (_this.isDefaultTabSetting) {
                        _this.openInternalLink(linkButtonSetting.to);
                    }
                    else {
                        _this.openInternalLink(linkButtonSetting.to, linkButtonSetting.newTab);
                    }
                    break;
                case 'external':
                    if (_this.isDefaultTabSetting) {
                        _this.openExternalLink(linkButtonSetting.to);
                    }
                    else {
                        _this.openExternalLink(linkButtonSetting.to, linkButtonSetting.newTab);
                    }
                    break;
                case 'referrer':
                    if (_this.isDefaultTabSetting) {
                        _this.backToReferrer();
                    }
                    else {
                        _this.backToReferrer(linkButtonSetting.newTab);
                    }
                    break;
            }
        };
        this.getLinkSetting = function (screenId) {
            if (screenId === void 0) { screenId = _this.currentId; }
            return _this.linkButtonSettings[screenId] || [];
        };
        this.getAlwaysHiddenButtons = function (screenId) {
            return _this.alwaysHiddenButtonsList[screenId] || [];
        };
        if (fragmentId.match(MierukaWebViewer.HASH_FOR_INTERNAL_LINK)) {
            this.isInternalLinkProcess = true;
            var extractedFragmentId = fragmentId.replace(MierukaWebViewer.HASH_FOR_INTERNAL_LINK, '');
            if (extractedFragmentId && !extractedFragmentId.match('[^0-9]'))
                this.firstFragedScreenId = Number(extractedFragmentId);
        }
        else if (fragmentId && !fragmentId.match('[^0-9]')) {
            this.firstFragedScreenId = Number(fragmentId);
        }
        this.referrerUrl = referrerUrl;
        $(window).on('hashchange', function () {
            if (!_this.isInitialized)
                return;
            var newFragmentId = location.hash.substring(1);
            _this.validateFragmentId(newFragmentId);
        });
    }
    Object.defineProperty(MierukaWebViewer.prototype, "isAutoCruise", {
        get: function () {
            return this._isAutoCruise;
        },
        enumerable: false,
        configurable: true
    });
    MierukaWebViewer.prototype.setUp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var showPreLoader, confGetter, getConf, parseConf, initworker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.showPreLoader()];
                    case 1:
                        showPreLoader = _a.sent();
                        confGetter = new ConfGetter_1.ConfGetter();
                        return [4, confGetter.getConf()];
                    case 2:
                        getConf = _a.sent();
                        return [4, this.parseConf()];
                    case 3:
                        parseConf = _a.sent();
                        if (this.isConfigV3(DataContainer_1.DataContainer.config))
                            this.setUpForLinkableCrusing();
                        this.dataGetter = new DataGetter_1.DataGetter();
                        this.dataGetter.initialCallBack = this.isCrusingWithList
                            ? { method: this.showScreen, arg: this.firstFragedScreenId }
                            : { method: this.showScreen, arg: 0 };
                        this.dataGetter.onDataUpdateCallBack = this.updateValue;
                        return [4, this.dataGetter.init()];
                    case 4:
                        initworker = _a.sent();
                        ChartManager_1.ChartManager.init();
                        setInterval(this.reboot, 1000 * 60 * 60);
                        return [2];
                }
            });
        });
    };
    MierukaWebViewer.prototype.getValue = function (datasetId, keys) {
        if (datasetId == '' || keys.length == 0) {
            return Number.NaN;
        }
        var dataSet = DataContainer_1.DataContainer.getDataSetById(datasetId);
        var result = lodash_1.default.get(dataSet, keys);
        if ((0, isNumeric_1.isNumeric)(result)) {
            return Number(result);
        }
        return Number.NaN;
    };
    MierukaWebViewer.prototype.isEmptyObject = function (value) {
        return value !== null && typeof value === 'object' && Object.keys(value).length === 0;
    };
    MierukaWebViewer.prototype.getItemValue = function (itemKey) {
        var defaultRound = 1;
        var data = Number.NaN;
        var result = '--';
        try {
            var itemConf = this.getItemConf(itemKey);
            if (this.isEmptyObject(itemConf))
                return result;
            var refferrer = itemConf.dataReferrer;
            if ((0, isNumeric_1.isNumeric)(refferrer.nodeId)) {
                data = this.getValue(refferrer.targetId, [
                    'skeleton',
                    'node',
                    String(refferrer.nodeId),
                    refferrer.level,
                    refferrer.type,
                ]);
            }
            else {
                data = this.getValue(refferrer.targetId, ['skeleton', refferrer.level, refferrer.type]);
            }
            if ((0, isNumeric_1.isNumeric)(data)) {
                if ((0, isNumeric_1.isNumeric)(itemConf.coefficient)) {
                    data = data * itemConf.coefficient;
                }
                if ((0, isNumeric_1.isNumeric)(itemConf.round)) {
                    result = data.toFixed(itemConf.round);
                }
                else {
                    result = data.toFixed(defaultRound);
                }
                return this.formatNumber(result);
            }
            return result;
        }
        catch (error) {
            return result;
        }
    };
    MierukaWebViewer.prototype.getItemConf = function (itemKey) {
        var itemConfigList = this.getCurrentScreenConf().config;
        if (!(itemConfigList.length && itemConfigList.every(this.isScreenConfigSkeleton)))
            return {};
        for (var _i = 0, itemConfigList_1 = itemConfigList; _i < itemConfigList_1.length; _i++) {
            var itemConfig = itemConfigList_1[_i];
            for (var prop in itemConfig.item) {
                if (prop === itemKey) {
                    var item = itemConfig.item[prop];
                    item.enable = DataContainer_1.DataContainer.getItemEnable(item.dataReferrer);
                    return item;
                }
            }
        }
        return {};
    };
    MierukaWebViewer.prototype.parseConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                this.screenCount = DataContainer_1.DataContainer.config.screens.length;
                for (index = 0; index < this.screenCount; index++) {
                    this.createFrame(index);
                }
                $('#count').text(this.screenCount - 1);
                return [2];
            });
        });
    };
    MierukaWebViewer.FRAGMENTABLE_VERSION = 3;
    MierukaWebViewer.URL_WITHOUT_HASH = "".concat(location.protocol, "//").concat(location.host).concat(location.pathname);
    MierukaWebViewer.HASH_FOR_INTERNAL_LINK = 'withInternalLink';
    return MierukaWebViewer;
}());
